import t from "./index808.js";
function o(e) {
  return function(r) {
    return t(r, e);
  };
}
export {
  o as default
};
